<template lang="html">
  <b-modal
    id="modalOTP"
    v-model="modalShowOTP"
    class="text-center"
    centered="centered"
    title="Confirmation"
    no-close-on-esc="no-close-on-esc"
    hide-header="hide-header"
    hide-footer="hide-footer"
    no-close-on-backdrop="no-close-on-backdrop"
    @hidden="hideModal"
  >
    <div class="row">
      <div class="col">
        <span class="volo-small-label font-weight-bold">{{ $t('account_otp_head') }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col small-new-line">
        <span class="volo-small-label">{{ $t('otp_desc') }}</span>
      </div>
    </div>
    <div class="row pin-container">
      <div class="col p-0">
        <input
          ref="box1"
          :class="{ error: errorData }"
          v-model="pinData[0]"
          class="form-control pin-input"
          type="number"
          data-cy="modalOTPOTP1"
          @focus="
            $event.target.select();
            errorData = false;
          "
          @keyup="goNext('pin1', 0)"
        />
      </div>
      <div class="col p-0">
        <input
          ref="pin1"
          :class="{ error: errorData }"
          v-model="pinData[1]"
          class="form-control pin-input"
          type="number"
          data-cy="modalOTPOTP2"
          @focus="
            $event.target.select();
            errorData = false;
          "
          @keyup="goNext('pin2', 1)"
        />
      </div>
      <div class="col p-0">
        <input
          ref="pin2"
          :class="{ error: errorData }"
          v-model="pinData[2]"
          class="form-control pin-input"
          type="number"
          data-cy="modalOTPOTP3"
          @focus="
            $event.target.select();
            errorData = false;
          "
          @keyup="goNext('pin3', 2)"
        />
      </div>
      <div class="col p-0">
        <input
          ref="pin3"
          :class="{ error: errorData }"
          v-model="pinData[3]"
          class="form-control pin-input"
          type="number"
          data-cy="modalOTPOTP4"
          @focus="
            $event.target.select();
            errorData = false;
          "
          @keyup="goNext('pin1', 3)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <span class="invalid-feedback d-block">{{ errorMsg }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-form>
          <div class="form-group">
            <button
              :disabled="pinData.length < 4"
              class="btn volo-button volo-small-label m-0"
              type="button"
              data-cy="modalOTPSubmitOTP"
              @click="sendPin"
            >
              {{ $t('submit') }}
            </button>
          </div>
        </b-form>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-form>
          <div class="form-group">
            <button
              :disabled="countdown"
              class="btn volo-button volo-small-label m-0"
              type="button"
              data-cy="modalOTPResendOTP"
              @click="resendOTP"
            >
              {{ $t('otp_resend') }} {{ textCountdown }}
            </button>
          </div>
        </b-form>
      </div>
    </div>
    <div class="row">
      <div class="col" @click="hideModalPress">
        <span class="volo-small-label qoala-primary-text" data-cy="modalOTPCancelOTP">{{ $t('otp_cancel') }}</span>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      modalShowOTP: false,
      errorMsg: '',
      counter: null,
      countdown: true,
      textCountdown: '',
      errorData: false,
      pinData: []
    };
  },
  created() {
    this.pinData = this.$store.getters['general/getPin'] || [];
    this.modalShowOTP = this.$store.getters['general/getOTPStatus'];
  },
  methods: {
    showModal() {
      this.modalShowOTP = true;
      this.intervalCountdown();
      this.$store.commit('updateOTPStatus', true);
    },
    resendOTP() {
      this.$emit('resend-pin');
      this.intervalCountdown();
      this.countdown = true;
    },
    hideModalPress() {
      this.hideModal();
    },
    hideModal() {
      this.modalShowOTP = false;
      this.pinData = [];
      this.errorMsg = '';
      clearInterval(this.counter);
      this.textCountdown = '';
      this.$store.commit('general/updatePin', []);
      this.$store.commit('general/updateOTPStatus', false);
    },
    goNext(ref, data) {
      if (this.pinData[data].length > 1) {
        this.pinData[data] = this.pinData[data].substring(0, 1);
      }
      this.$store.commit('updatePin', this.pinData);
      if (this.pinData.length === 4) this.sendPin();
      else if (this.pinData[data]) this.$refs[ref].focus();
    },
    sendPin() {
      let pinSend = '';
      let i = 0;
      const iMax = this.pinData.length;
      for (; i < iMax; i++) {
        pinSend += this.pinData[i];
      }
      // this.hideModal();
      this.$emit('send-pin', pinSend);
    },
    intervalCountdown() {
      let countdownTime = 1 * 60 * 1000; // 5 minutes countdown
      const pointer = this;
      if (this.counter) clearInterval(this.counter);
      this.counter = setInterval(() => {
        const minutes = Math.floor((countdownTime % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((countdownTime % (1000 * 60)) / 1000);
        countdownTime -= 1000;
        try {
          pointer.textCountdown = `${minutes > 0 ? `${minutes} ${pointer.$t('minutes')} ` : ''}
                    ${seconds} ${pointer.$t('seconds')} ${pointer.$t('please_wait')}`;
        } catch (error) {
          clearInterval(pointer.counter);
        }
        if (countdownTime < 0) {
          clearInterval(pointer.counter);
          pointer.countdown = false;
          pointer.textCountdown = pointer.$t('resend_text');
        }
      }, 1000);
    },
    setErrorMsg(msg) {
      this.errorMsg = msg;
      this.errorData = true;
      this.pinData = [];
      this.$refs.box1.focus();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~/assets/css/var.scss';

.pin-container {
  width: 210px;
  margin: 10px auto;
}

.pin-input {
  height: 48px;
  width: 48px;
  padding: 0px;
  text-align: center;
  border: 0px;
  background-color: $gray-light;
  color: $primary-color;
  margin: auto;
  border-radius: 0px;
}

.pin-input.error {
  border: 0.5px solid red;
}
</style>
